export const apiBaseUrl = process.env.REACT_APP_LOCAL_API ? process.env.REACT_APP_LOCAL_API_FUNCTIONS_REST_URL : process.env.REACT_APP_FUNCTIONS_REST_URL;

export const apiMgmtSubscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY || '';

export const maxProductsPerRequisition: number | undefined = process.env.REACT_APP_IPM_MAX_PRODUCTS_PER_REQUISITION ?
  parseInt(process.env.REACT_APP_IPM_MAX_PRODUCTS_PER_REQUISITION, 10) : undefined;

export const minutesUntilLogoutPrompt = Number(process.env.REACT_APP_MINUTES_UNTIL_LOGOUT_PROMPT) ?? 14;
